"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _moment = _interopRequireDefault(require("moment"));

var _material = require("@mui/material");

var _styles = require("@mui/styles");

var _dateFormat = require("../../constants/date-format.constants");

var useStyles = (0, _styles.makeStyles)(function (_ref) {
  var palette = _ref.palette;
  return {
    productImage: {
      width: 60,
      height: 60,
      border: "2px solid ".concat(palette.text.disabled)
    },
    productTitle: {
      fontSize: 14,
      color: palette.text.primary
    },
    productStatus: {
      fontSize: 20,
      color: palette.primary.main
    },
    productDate: {
      fontSize: 14,
      color: palette.grey.main
    }
  };
});

var Product = function Product(_ref2) {
  var name = _ref2.name,
      image = _ref2.image,
      date = _ref2.date,
      status = _ref2.status;
  var classes = useStyles();
  var localDate = (0, _react.useMemo)(function () {
    return (0, _moment.default)(date).local().format(_dateFormat.USER_FULL_NUMBER_DATE_FORMAT);
  }, [date]);
  return /*#__PURE__*/_react.default.createElement(_material.Grid, {
    container: true,
    direction: "row"
  }, /*#__PURE__*/_react.default.createElement(_material.Box, {
    display: "flex",
    flexDirection: "row",
    flexWrap: "nowrap",
    alignItems: "center"
  }, /*#__PURE__*/_react.default.createElement(_material.Box, {
    width: 1 / 4
  }, /*#__PURE__*/_react.default.createElement("img", {
    alt: name,
    className: classes.productImage,
    src: image
  })), /*#__PURE__*/_react.default.createElement(_material.Box, {
    width: 3 / 4,
    m: 1
  }, /*#__PURE__*/_react.default.createElement(_material.Typography, {
    className: classes.productTitle
  }, name), /*#__PURE__*/_react.default.createElement(_material.Typography, {
    className: classes.productStatus
  }, status), /*#__PURE__*/_react.default.createElement(_material.Typography, {
    className: classes.productDate
  }, localDate))));
};

Product.propTypes = {
  name: _propTypes.default.string.isRequired,
  image: _propTypes.default.string.isRequired,
  date: _propTypes.default.string.isRequired,
  status: _propTypes.default.string.isRequired
};
var _default = Product;
exports.default = _default;